(function (window) {
    function Webridge() {
        // 私有变量
        var sequence = 0;
        var callbackArray = [];
        var nativeToJsDefaultFunction = 'jsToNativeCallback';
        var isApp = window.navigator.userAgent.indexOf('dyxc') > -1 || window.navigator.userAgent.indexOf('dyxc') > -1;
        this.jsToNative = function (options) {
          if(isApp) {
            var params = handleOption(options);
            window.prompt(JSON.stringify(params));
          }else{
            console.log('bridge 只允许 app 内使用');
            return false;
          }
        };

        function handleOption(options) {
            var params = {
                handler: options.handler ? options.handler : '',
                action: options.action ? options.action : '',
                params: options.params ? options.params : {},
                msgType: options.msgType ? options.msgType : false,
                callbackId: '',
                callbackFunction: ''
            };
            if (options.callback) {
                sequence += 1;
                callbackArray[sequence] = options.callback;
                params.callbackId = sequence;
                params.callbackFunction = nativeToJsDefaultFunction;
            }
            return params;
        }

        window[nativeToJsDefaultFunction] =  function (jsSequence, result) {
            var jsCallback = callbackArray[jsSequence];
            jsCallback(result);
            delete callbackArray[jsSequence];
        };
    }
    window.webridge = new Webridge();
})(window);
